import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import type { FunctionComponent, ReactElement } from 'react';

type CardPlaceholderProps = {
    readonly placeholderIcon: ReactElement<any>;
    readonly placeholderText: string;
};

export const CardPlaceholder: FunctionComponent<CardPlaceholderProps> = (props) => (
    <CardContent sx={{ p: 3 }}>
        <Container>
            <Box alignItems="center" display="flex" flexDirection="column" width="100%">
                {props.placeholderIcon}
            </Box>
            <Typography textAlign="center" variant="body1" width="100%">
                {props.placeholderText}
            </Typography>
        </Container>
    </CardContent>
);
